import { deriveConfigScope } from './deriveConfigScope'
import { ConfigScope } from '../types'
import type { ConfigDTO } from '../types'

function buildRelationshipSuffix(
  scope: ConfigScope,
  tenantCode: string | null,
  inventorySystemProfileCode: string | null,
  venueId: string | null,
): string {
  switch (scope) {
    case ConfigScope.IspConfig:
      return [inventorySystemProfileCode].filter(Boolean).join(', ')
    case ConfigScope.TenantConfig:
      return [tenantCode].filter(Boolean).join(', ')
    case ConfigScope.TenantIspConfig:
      return [tenantCode, inventorySystemProfileCode].filter(Boolean).join(', ')
    case ConfigScope.TenantVenueConfig:
      return [tenantCode, venueId].filter(Boolean).join(', ')
  }
}

export function buildConfigDetailTitle(config: ConfigDTO): string {
  const scope = deriveConfigScope(config)
  if (!scope) return 'Config'
  const suffix = buildRelationshipSuffix(
    scope,
    config.tenantCode,
    config.inventorySystemProfileCode,
    config.venueId,
  )
  return `${scope} - ${config.configKey} (${suffix})`
}
